<template>
  <div>
    <b-button @click="showModal = !showModal" variant="secondary"><b-icon-plus/> Add New</b-button>
    <base-table
        :items="expenseProjects"
        :fields="fields"
        :show-title="true"
        :is-busy="projection.projectionLoading"
        class="mt-2"
    ></base-table>
    <expense-modal :show="showModal" :row="{}"/>
  </div>
</template>

<script>
import BaseTable from "@/components/table/BaseTable";
import {mapState} from 'vuex'
import ExpenseModal from "@/components/modal/projection/ExpenseModal";
export default {
  name: "ExpenseProjectionTable",
  components:{
    ExpenseModal,
    BaseTable
  },
  data(){
    return {
      showModal: false,
      fields: [
        { key: 'serial', label: 'S/N', sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'expenseProjectionAmount', label: 'Amount', sortable: true, sortDirection: 'desc', class: 'text-right' },
        { key: 'expenseProjectionType', label: 'Type', sortable: true, sortDirection: 'desc', class: 'text-left' },
        { key: 'expenseProjectionMonth', label: 'Month', sortable: true, class: 'text-left' },
        { key: 'expenseProjectionCashComponent', label: 'Cash Component', sortable: true, class: 'text-right' },
        { key: 'expenseProjectionStatus', label: 'Status', sortable: true, class: 'text-left' },
        { key: 'expenseProjectionCreatedAt', label: 'Created At', sortable: true, class: 'text-left' },
        { key: 'actionsExpense', label: 'Action', sortable: true, class: 'text-left' }
      ],
    }
  },
  methods: {
    loadData() {
      this.$store.dispatch('projection/updateExpenseProjection',{expenseProjectionCampaignId: localStorage.campaignId})
    }
  },
  computed:{
    expenseProjects:{
      get(){
        return this.projection.expenseProjections.data
      },
      set(val){
        this.$store.commit('projection/updateExpenseProjection', val)
      }
    },
    ...mapState([
        'auth',
        'projection'
    ])
  },
  mounted() {
    this.loadData();
  },
}
</script>

<style scoped>

</style>